module.exports = __webpack_public_path__ + "img/travel-agency__final-design.17832d60.jpg";